import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=3fcca483&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=3fcca483&prod&scoped=true&lang=css"
import style1 from "./MainNavigation.vue?vue&type=style&index=1&id=3fcca483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcca483",
  null
  
)

export default component.exports